<style lang="scss" scoped>
.testimonial-row {
    .testimonials-wrapper {
        position: relative;

        @media screen and (min-width: 1024px) {
            height: 366px;
        }

        .image-carousel {
            position: relative;
            height: 268px;

            @media screen and (min-width: 768px) {
                height: 460px;
            }
        }

        .center-wrapper {
            position: absolute;
            top: 0;
            height: 268px;
            left: 50%;
            transform: translateX(-50%);

            @media screen and (min-width: 768px) {
                height: 460px;
            }

            @media screen and (min-width: 1024px) {
                height: 366px;
            }

            &.even {
                transform: translateX(93.415px) translateX(-50%);

                @media screen and (min-width: 768px) {
                    transform: translateX(139.565px) translateX(-50%);
                }

                @media screen and (min-width: 1024px) {
                    transform: translateX(113.5px) translateX(-50%);
                }
            }
        }

        .left-wrapper {
            height: 100%;
        }

        .content-wrapper {
            width: 544px;
            position: relative;

            @media screen and (min-width: 1280px) {
                width: 544px;
            }

            @media screen and (min-width: 1650px) {
                width: 670px;
            }

            > div {
                position: absolute;
                width: calc(100% - 80px);
                top: 0;
            }
        }

        .right-wrapper {
            height: 100%;
        }

        blockquote {
            font-size: 24px;
            font-weight: 200;
            line-height: 36px;

            @media screen and (max-width: 1023.98px) {
                font-size: 1.5rem;
                line-height: 1.2;
            }
        }

        .author {
            font-size: 1rem;
        }

        &.hide-navigation {
            .control {
                display: none;
            }
        }

        &.little-items {
            .center-wrapper {
                left: -8px !important;
                transform: none !important;

                @media screen and (min-width: 1024px) {
                    left: 0 !important;
                }
            }

            .control {
                display: none;
            }
        }
    }
}

.image-wrapper {
    height: 100%;
    position: relative;
    margin: 0 8px;
    cursor: pointer;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently */

    @media screen and (min-width: 768px) {
        margin: 0 12px;
    }

    img {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        font-family: "object-fit: cover;";
        border-radius: 4px;
    }

    &:after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        background-color: #fff;
        opacity: 0.7;
        transition: opacity 0.15s;
    }

    &:hover {
        &:after {
            opacity: 0;
        }
    }

    &.active {
        cursor: default;

        &:after {
            opacity: 0;
        }
    }
}

.control {
    position: absolute;
    top: 0;
    height: 268px;
    width: 36px;
    z-index: 2;
    cursor: pointer;

    @media screen and (min-width: 768px) {
        height: 460px;
    }

    @media screen and (min-width: 1024px) {
        height: 100%;
    }

    &:after {
        position: absolute;
        top: calc(50% - 7px);
        width: 26px;
        height: 14px;
        transition: transform 0.2s;
    }

    &.prev {
        left: 0;

        &:after {
            left: 8px;
            content: url("/svg/chevron-left.svg");
            transform: translateY(-5px);
        }

        &:hover {
            &:after {
                transform: translateX(-6px) translateY(-5px);
            }
        }
    }

    &.next {
        right: 0;

        &:after {
            right: 8px;
            content: url("/svg/chevron-right.svg");
            transform: rotate(180deg) translateY(-7px);
        }

        &:hover {
            &:after {
                transform: translateX(6px) rotate(180deg) translateY(-7px);
            }
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>

<template>
    <div class="testimonial-row">
        <div class="container">
            <h3 class="mb-40">{{ title }}</h3>
        </div>

        <div class="testimonials-wrapper" :class="{'hide-navigation': !navigationVisible, 'container little-items': this.testimonials.length <= 2}" ref="testimonialsWrapper">
            <div class="prev control" @click="previous"></div>
            <div class="d-none d-lg-block">
                <div class="center-wrapper d-flex" :class="{'even': this.testimonials.length % 2 === 0}" ref="center">
                    <div class="left-wrapper d-flex" :class="{'flex-row-reverse': this.testimonials.length <= 2}">
                        <div class="image-wrapper" :class="{'active': testimonial === activeTestimonial}" v-for="testimonial in leftTestimonials" :key="testimonial.id" :style="{'width': imageWidth}" @click="sortTestimonials(testimonial.id)">
                            <transition name="fade">
                                <img :src="testimonial.acf.images[0].sizes.medium_large" :alt="testimonial.post_title">
                            </transition>
                        </div>
                    </div>
                    <div class="content-wrapper px-40">
                        <transition name="fade">
                            <div v-if="activeTestimonial != null" :key="activeTestimonial.id" class="d-flex align-items-start flex-column justify-content-center">
                                <blockquote class="mb-24">{{ activeTestimonial.acf.quote }}</blockquote>
                                <span class="d-block author font-weight-light" v-html="activeTestimonial.post_title"></span>
                                <a v-if="activeTestimonial.acf.story != null && activeTestimonial.acf.story.length > 0" :href="route('nl.story', {'slug': activeTestimonial.acf.story[0].post_name})" class="btn btn-accent mt-24">Lees het verhaal</a>
                            </div>
                        </transition>
                    </div>
                    <div class="right-wrapper d-flex">
                        <div class="image-wrapper" v-for="testimonial in rightTestimonials" :key="testimonial.id" :style="{'width': imageWidth}" @click="sortTestimonials(testimonial.id)">
                            <transition name="fade">
                                <img :src="testimonial.acf.images[0].sizes.medium_large" :alt="testimonial.post_title">
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-lg-none">
                <div class="image-carousel mb-40" :class="{'single': this.testimonials.length === 1}" ref="imageCarousel">
                    <div class="center-wrapper d-flex" :class="{'even': this.testimonials.length % 2 === 0}" ref="mobileCenter">
                        <div class="image-wrapper" :class="{'active': testimonial === activeTestimonial}" v-for="testimonial in allSortedTestimonials" :key="testimonial.id" :style="{'width': imageWidth}" @click="sortTestimonials(testimonial.id)">
                            <transition name="fade">
                                <img :src="testimonial.acf.images[0].sizes.medium_large" :alt="testimonial.post_title">
                            </transition>
                        </div>
                    </div>
                </div>
                <div :class="{'container': this.testimonials.length > 2}">
                    <div v-if="activeTestimonial != null" :key="activeTestimonial.id" class="d-flex align-items-start flex-column justify-content-center">
                        <blockquote class="mb-24">{{ activeTestimonial.acf.quote }}</blockquote>
                        <span class="d-block author font-weight-light" v-html="activeTestimonial.post_title"></span>
                        <a v-if="activeTestimonial.acf.story != null && activeTestimonial.acf.story.length > 0" :href="route('nl.story', {'slug': activeTestimonial.acf.story[0].post_name})" class="btn btn-accent mt-40 mt-lg-24">Lees het verhaal</a>
                    </div>
                </div>
            </div>
            <div class="next control" @click="next"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "pagePart.new-testimonial-row",

    props: {
        testimonials: {
            type: Array,
            required: true,
            default: () => {
                return []
            },
        },

        title: {
            type: String,
            required: true
        },

        ratio: {
            type: [String, Boolean],
            default: '203:366',
            required: false
        }
    },

    data: () => ({
        wrapperHeight: 0,
        sortedTestimonials: [],
        currentTestimonial: null,
        testimonialsLength: 0,
        showNavigation: false
    }),

    mounted() {
        let self = this;

        this.testimonialsLength = this.testimonials.length;
        this.calculateHeight();
        this.sortedTestimonials = this.testimonials;
        this.currentTestimonial = this.testimonials[0];

        this.sortTestimonials(this.currentTestimonial.id);

        function toggleNavigation() {
            let sliderWidth = 0;

            if (window.innerWidth >= 1024) {
                sliderWidth = self.$refs.center.clientWidth;
            } else {
                sliderWidth = self.$refs.mobileCenter.clientWidth;
            }

            sliderWidth >= window.innerWidth ? self.showNavigation = true : self.showNavigation = false;

            self.calculateHeight();
        }

        window.addEventListener('resize', toggleNavigation);
        window.addEventListener('orientationchange', toggleNavigation);
        this.$nextTick(toggleNavigation);
    },

    methods: {
        calculateHeight() {
            let height = window.innerWidth >= 1024 ? this.$refs.testimonialsWrapper.clientHeight : this.$refs.imageCarousel.clientHeight;
            this.wrapperHeight = height;
        },

        sortTestimonials(id) {
            let index = this.sortedTestimonials.findIndex(t => t.id === id);
            let testimonial = this.sortedTestimonials[index];
            let firstPart = [];
            let secondPart = [];

            for (let i = 0; i < this.testimonialsLength; i++) {
                if (i <= this.testimonialsLength / 2 && this.testimonialsLength > 2) {
                    secondPart.push(this.sortedTestimonials[index]);
                } else {
                    firstPart.push(this.sortedTestimonials[index]);
                }

                if (index + 1 >= this.testimonialsLength) {
                    index = 0;
                } else {
                    index++;
                }
            }

            this.sortedTestimonials = firstPart.concat(secondPart);
            this.currentTestimonial = testimonial;
        },

        previous() {
            this.sortTestimonials(this.sortedTestimonials[this.activeIndex - 1].id);
        },

        next() {
            this.sortTestimonials(this.sortedTestimonials[this.activeIndex + 1].id);
        }
    },

    computed: {
        imageWidth() {
            return `${(this.arWidth / this.arHeight) * this.getWrapperHeight}px`
        },

        activeIndex() {
            let index = Math.round(this.sortedTestimonials.length / 2) - 1;
            if (this.sortedTestimonials.length == 2) return 1;
            return index;
        },

        activeTestimonial() {
            return this.currentTestimonial;
        },

        allSortedTestimonials() {
            return this.sortedTestimonials;
        },

        leftTestimonials() {
            if (this.sortedTestimonials.length <= 2) return this.sortedTestimonials;
            return this.sortedTestimonials.slice(0, this.activeIndex + 1);
        },

        rightTestimonials() {
            if (this.sortedTestimonials.length <= 2) return [];
            return this.sortedTestimonials.slice(this.activeIndex + 1);
        },

        getWrapperHeight() {
            return this.wrapperHeight;
        },

        arWidth() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[0]
        },

        arHeight() {
            if (!this.ratio) return 0
            return this.ratio.split(':')[1]
        },

        navigationVisible() {
            return this.showNavigation;
        }
    }
}
</script>
